import { Component, OnInit, Input } from '@angular/core';
import { WMAIApiService, Ost, Immagine } from '../../core';
import { WgisService } from '../../wgis/wgis.service';
import { Angulartics2 } from 'angulartics2';
@Component({
    selector: 'app-ost-result',
    templateUrl: './ost-result.component.html',
})
export class OstResultComponent implements OnInit {
    @Input()
    ost: Ost;
    immagini: any[];
    immagine: Immagine;

    constructor(private wmaiservice: WMAIApiService, private wgisservice: WgisService, private angulartics2: Angulartics2) {
        this.angulartics2.eventTrack.next({
            action: 'onShare',
            properties: { label: 'EsperienzaProfileShare' },
        });
        this.angulartics2.eventTrack.next({
            action: 'onMouseEnter',
            properties: { label: 'EsperienzaProfileMouseEnter' },
        });
    }
    ngOnInit() {
        window.scrollTo(0, 0);
        if(this.ost.immagine != null && this.ost.immagine.length > 0){
            this.immagine = this.ost.immagine[0];
          }
    }
    onMouseEnter(ost: Ost) {
        this.wgisservice.showOstByObj(ost);
    }
}
